import {SVGIcon} from 'types';

import AiAssistIcon from 'components/icons/aiAssist.svg';
import HomeIcon from 'components/icons/pages/home.svg';
import AccountsIcon from 'components/icons/metrics/accounts.svg';
import BookmarkIcon from 'components/icons/bookmark.svg';
import CarrierAppetiteIcon from 'components/icons/pages/carrier-appetite.svg';
import CodeIcon from 'components/icons/code.svg';
import ProducersIcon from 'components/icons/metrics/producers.svg';
import AccountExecutivesIcon from 'components/icons/metrics/accountExecutives.svg';
import ProductsIcon from 'components/icons/metrics/products.svg';
import MarketsIcon from 'components/icons/metrics/carriers.svg';
import ReportsIcon from 'components/icons/pages/report-studio.svg';
import AccountManagersIcon from 'components/icons/metrics/managers.svg';
import IndustriesIcon from 'components/icons/metrics/industries.svg';
import ProspectsIcon from 'components/icons/prospect.svg';
import GrowthIcon from 'components/icons/pages/growth.svg';
import RetentionIcon from 'components/icons/pages/retention.svg';
import RenewalsIcon from 'components/icons/renewals.svg';
import OverviewIcon from 'components/icons/overview.svg';
import O360ScoreIcon from 'components/icons/pages/o360.svg';
import DocumentsIcon from 'components/icons/files/document.svg';
import KPIIcon from 'components/icons/pages/kpi.svg';
import LossRunsIcon from 'components/icons/pages/loss-runs.svg';
import OpportunitiesIcon from 'components/icons/pages/opportunities.svg';
import InsightsIcon from 'components/icons/pages/insights.svg';
import AccountSettingsIcon from 'components/icons/accountSettings.svg';
import FavoriteIcon from 'components/icons/topbar/favorites.svg';
import FavoriteFilledIcon from 'components/icons/topbar/favoritesFilled.svg';
import FiltersIcon from 'components/icons/filters.svg';
import FiltersFilledIcon from 'components/icons/filters-filled.svg';
import CopyIcon from 'components/icons/topbar/copy.svg';
import CopyFilledIcon from 'components/icons/topbar/copyFilled.svg';
import SettingsIcon from 'components/icons/settings.svg';
import SwitchIcon from 'components/icons/topbar/switch.svg';
import LogOutIcon from 'components/icons/topbar/logout.svg';
import StorybookIcon from 'components/icons/storybook.svg';
import MonolineRatios from 'components/icons/monoline.svg';
import ActivitiesIcon from 'components/icons/activities.svg';
import WhatsNewIcon from 'components/icons/news.svg';

import {IconKey} from './types';

export const iconSvgMap = {
  [IconKey.AI]: AiAssistIcon,
  [IconKey.Opportunities]: OpportunitiesIcon,
  [IconKey.AccountExecutives]: AccountExecutivesIcon,
  [IconKey.AccountSettings]: AccountSettingsIcon,
  [IconKey.Home]: HomeIcon,
  [IconKey.Favorite]: FavoriteIcon,
  [IconKey.FavoriteFilled]: FavoriteFilledIcon,
  [IconKey.Filters]: FiltersIcon,
  [IconKey.FiltersFilled]: FiltersFilledIcon,
  [IconKey.Accounts]: AccountsIcon,
  [IconKey.Bookmark]: BookmarkIcon,
  [IconKey.CarrierAppetite]: CarrierAppetiteIcon,
  [IconKey.Code]: CodeIcon,
  [IconKey.Copy]: CopyIcon,
  [IconKey.CopyFilled]: CopyFilledIcon,
  [IconKey.Producers]: ProducersIcon,
  [IconKey.Products]: ProductsIcon,
  [IconKey.Markets]: MarketsIcon,
  [IconKey.Reports]: ReportsIcon,
  [IconKey.AccountManagers]: AccountManagersIcon,
  [IconKey.Industries]: IndustriesIcon,
  [IconKey.Insights]: InsightsIcon,
  [IconKey.Prospects]: ProspectsIcon,
  [IconKey.Growth]: GrowthIcon,
  [IconKey.Retention]: RetentionIcon,
  [IconKey.Renewals]: RenewalsIcon,
  [IconKey.Overview]: OverviewIcon,
  [IconKey.O360Score]: O360ScoreIcon,
  [IconKey.Documents]: DocumentsIcon,
  [IconKey.KPI]: KPIIcon,
  [IconKey.LossRuns]: LossRunsIcon,
  [IconKey.Settings]: SettingsIcon,
  [IconKey.Switch]: SwitchIcon,
  [IconKey.Storybook]: StorybookIcon,
  [IconKey.LogOut]: LogOutIcon,
  [IconKey.MonolineRatios]: MonolineRatios,
  [IconKey.RetailClients]: AccountsIcon,
  [IconKey.Activities]: ActivitiesIcon,
  [IconKey.WhatsNew]: WhatsNewIcon,
} satisfies Record<IconKey, SVGIcon>;
